/*
 * Response styles and model
 */

define(["backbone", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Messenger,
  Properties,
) {
  const ResponseStylesModel = {};
  ResponseStylesModel.responseStyles = Backbone.Model.extend({
    defaults: {
      responseStyles: "",
    },
    initializeCustom: function () {
      this.set("kbId", Messenger.reqres.request("active:kb"));
    },
    url: function () {
      return `${Properties.rootURL}/${this.get("kbId")}/responseStyles`;
    },
  });

  Messenger.reqres.setHandler(
    "fetch:kb:responseStyles",
    function () {
      const model = new ResponseStylesModel.responseStyles();
      model.fetch();
      return model;
    },
    this,
  );
  return ResponseStylesModel;
});
